/** @format */

export const utilitySetControllerTimeEnd = (controller: AbortController) => {
  const timeOutId = setTimeout(() => controller.abort(), 30000);

  return timeOutId;
};
